export const TRANSITION_DURATION = {
  xs: 0.1,
  sm: 0.15,
  md: 0.2,
  lg: 0.25,
  xl: 0.3,
  '2xl': 0.35,
}
